import { render, staticRenderFns } from "./myUpdates.vue?vue&type=template&id=534984f9&scoped=true&"
import script from "./myUpdates.vue?vue&type=script&lang=js&"
export * from "./myUpdates.vue?vue&type=script&lang=js&"
import style0 from "./myUpdates.vue?vue&type=style&index=0&id=534984f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534984f9",
  null
  
)

export default component.exports